/* Timezone — время брони показываем в ВЫБРАННОЙ зоне, ровно как строятся фильтры по дате */
import { inTz, nowInTz } from "../../helpers/timezone"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"


/* HOW MANY FACES THE PANEL HAS — /images/player/gamer1..gamer11 */
const AVATARS = 11

/* HOW LONG BEFORE THE START A RESERVATION IS CALLED "SOON" — THE ROW STARTS GLOWING AT THAT POINT */
const SOON = 60


/* STATUSES OF THE COLUMN Bookings.status */
export const BOOKED = 0
export const ARRIVED = 1
export const CANCELLED = 2


/* AVATAR OF A PLAYER — THE SAME ID ALWAYS GETS THE SAME FACE */
export const getAvatar = (item) => {

    /* Check Tester — a test account has a face of its own */
    if (parseInt(item.isTester) === 1) {
        return utils.ava(0, "test")
    }

    /* Fields */
    const code = String(item.player ? item.player : "")
    let hash = 0

    /* Hash Of The ID */
    for (let index = 0; index < code.length; index++) {
        hash = (hash * 31 + code.charCodeAt(index)) % AVATARS
    }

    /* Send Result */
    return utils.ava(hash, "")
}


/* STATE OF A RESERVATION
 *
 * The column keeps three values only — booked, arrived and cancelled. Everything else is read from the clock:
 * a booked window that is already over means nobody came, a running one means the table is held right now */
export const getState = (item) => {

    /* Cancelled */
    if (parseInt(item.status) === CANCELLED) {
        return "cancelled"
    }

    /* Arrived */
    if (parseInt(item.status) === ARRIVED) {
        return "arrived"
    }

    /* Fields */
    const now = nowInTz()
    const start = inTz(item.startAt)
    const end = inTz(item.endAt)

    /* Missed — the window is over and the arrival was never marked */
    if (end.isBefore(now)) {
        return "missed"
    }

    /* Live — the table is held right now */
    if (!start.isAfter(now)) {
        return "live"
    }

    /* Soon — the player is expected within the hour */
    if (start.diff(now, "minutes") <= SOON) {
        return "soon"
    }

    /* Send Result */
    return "booked"
}


/* NAME OF THE STATE — THE VERY SAME WORD THE FILTER USES */
export const getStateText = (item) => {

    /* Fields */
    const state = getState(item)

    /* Send Result */
    return t(`book.state.${state}`)
}


/* NAME OF A GAME — A TABLE MAY ALREADY BE RENAMED, THEN THE SLUG IS ALL WE HAVE */
export const getGame = (item) => {

    /* Check Name */
    if (item.game) {
        return item.game
    }

    /* Check Slug */
    if (item.slug) {
        return item.slug
    }

    /* Send Result */
    return t("book.noGame")
}


/* NAME OF A PLAYER — THE SNAPSHOT OF THE FORM FIRST, THE LIVE NAME OF Users AFTER IT */
export const getPlayerName = (item) => {

    /* Check Account */
    if (item.firstName) {
        return item.firstName
    }

    /* Check Snapshot */
    if (item.playerName) {
        return item.playerName
    }

    /* Send Result */
    return t("book.noName")
}


/* PLAIN NUMBER OF THE STATS */
export const formatCount = (value) => {

    /* Fields */
    const number = parseInt(value)

    /* Check Value */
    if (isNaN(number)) {
        return "0"
    }

    /* Send Result */
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}


/* DAY OF A RESERVATION */
export const formatDay = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY")
}


/* TIME OF A RESERVATION — THE WINDOW IS READ BY THE MINUTE, THE SECONDS MEAN NOTHING HERE */
export const formatTime = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("HH:mm")
}


/* FULL MOMENT OF A ROW — WHEN IT WAS WRITTEN, MARKED OR CANCELLED */
export const formatDate = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY HH:mm")
}


/* THE DAY A RESERVATION BELONGS TO — TODAY AND TOMORROW ARE NAMED, THE REST KEEPS THE DATE */
export const formatWhen = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Fields */
    const date = inTz(value)
    const now = nowInTz()

    /* Today */
    if (date.isSame(now, "day")) {
        return t("book.today")
    }

    /* Tomorrow */
    if (date.isSame(now.clone().add(1, "day"), "day")) {
        return t("book.tomorrow")
    }

    /* Yesterday */
    if (date.isSame(now.clone().subtract(1, "day"), "day")) {
        return t("book.yesterday")
    }

    /* Send Result */
    return date.format("DD.MM.YYYY")
}


/* WINDOW OF A RESERVATION — "21:00 — 23:30", AND THE DAY IS ADDED ONLY WHEN THE WINDOW CROSSES MIDNIGHT */
export const formatRange = (item) => {

    /* Check Value */
    if (!item.startAt || !item.endAt) {
        return "-"
    }

    /* Fields */
    const start = inTz(item.startAt)
    const end = inTz(item.endAt)

    /* One Day */
    if (start.isSame(end, "day")) {
        return `${start.format("HH:mm")} — ${end.format("HH:mm")}`
    }

    /* Send Result */
    return `${start.format("HH:mm")} — ${end.format("DD.MM HH:mm")}`
}


/* LENGTH OF A WINDOW — "2 ч 30 мин" */
export const formatDuration = (item) => {

    /* Check Value */
    if (!item.startAt || !item.endAt) {
        return "-"
    }

    /* Fields */
    const minutes = inTz(item.endAt).diff(inTz(item.startAt), "minutes")

    /* Check Value */
    if (minutes < 60) {
        return `${minutes} ${t("book.unit.minutes")}`
    }

    /* Fields */
    const hours = Math.floor(minutes / 60)
    const rest = minutes % 60

    /* Whole Hours */
    if (rest === 0) {
        return `${hours} ${t("book.unit.hours")}`
    }

    /* Send Result */
    return `${hours} ${t("book.unit.hours")} ${rest} ${t("book.unit.minutes")}`
}


/* A DISTANCE IN MINUTES WRITTEN IN WORDS — "2 ч 15 мин" */
const getDistance = (minutes) => {

    /* Minutes */
    if (minutes < 60) {
        return `${minutes} ${t("book.unit.minutes")}`
    }

    /* Hours */
    if (minutes < 60 * 24) {

        /* Fields */
        const hours = Math.floor(minutes / 60)
        const rest = minutes % 60

        /* Send Result */
        return rest === 0 ? `${hours} ${t("book.unit.hours")}` : `${hours} ${t("book.unit.hours")} ${rest} ${t("book.unit.minutes")}`
    }

    /* Days */
    const days = Math.floor(minutes / (60 * 24))
    const hours = Math.floor((minutes % (60 * 24)) / 60)

    /* Send Result */
    return hours === 0 ? `${days} ${t("book.unit.days")}` : `${days} ${t("book.unit.days")} ${hours} ${t("book.unit.hours")}`
}


/* THE LINE UNDER THE WINDOW — HOW FAR THE RESERVATION IS FROM NOW
 *
 * The upcoming tab reads it as a countdown, the history tab as a memory, so the very same row says
 * "через 2 ч" before the start, "идёт, до конца 40 мин" while the table is held and "было вчера" after it */
export const formatCountdown = (item) => {

    /* Check Value */
    if (!item.startAt || !item.endAt) {
        return ""
    }

    /* Fields */
    const now = nowInTz()
    const start = inTz(item.startAt)
    const end = inTz(item.endAt)

    /* Cancelled — the window means nothing anymore, the moment of the cancellation does */
    if (parseInt(item.status) === CANCELLED) {
        return item.cancelledAt ? `${t("book.cancelledAt")} ${formatDate(item.cancelledAt)}` : ""
    }

    /* Ahead */
    if (start.isAfter(now)) {
        return `${t("book.in")} ${getDistance(Math.max(start.diff(now, "minutes"), 1))}`
    }

    /* Running */
    if (!end.isBefore(now)) {
        return `${t("book.leftUntilEnd")} ${getDistance(Math.max(end.diff(now, "minutes"), 1))}`
    }

    /* Send Result */
    return `${t("book.ended")} ${getDistance(Math.max(now.diff(end, "minutes"), 1))} ${t("book.ago")}`
}
